import React from 'react';
import LoginPage from '../../components/LoginPage/LoginPage';

const Login = () => {
    return <LoginPage />;
};

export default Login;
